<template>
	<open-modal
		title="Guardar"
		color="primary"
		:create="$v.$invalid"
		:dialog="true"
		@close-modal="closeModal"
		@create-employee="saveType"
	>
		<div class="type-form-container">
			<h2>Nuevo Tipo</h2>
			<form :style="`color:${$appColors.info}`">
				<label class="name-input">
					Nombre
					<input
						class="new-survey-input" 
						placeholder="Nombre"
						v-model="newType.name"
					/>
				</label>
				<label class="level-input">
					Nivel
					<input
						class="new-survey-input" 
						v-model="newType.level"
					/>
				</label>
			</form>
		</div>
	</open-modal>
</template>
<script>
import openModal from '@/components/configuration/open-modal';
import { required } from 'vuelidate/lib/validators';

function closeModal() {
	const { toolCode, toolId } = this.$route.params;
	const params = { toolCode, toolId };
	this.goTo('levels-tool', { params });
}

async function saveType() {
	const body = {
		name: this.newType.name,
		number: Number(this.newType.level),
		toolId: Number(this.$route.params.toolId),
		toolCode: this.$route.params.toolCode,
	};
	try {
		await this.$store.dispatch('levelType/create', body);
		this.showNotification(
			`Se creó el nuevo nivel: "${this.newType.name}"`,
			'success',
		);
		setTimeout(() => {
			this.closeModal();
		}, 0);
	} catch (err) {
		if (err.data.message === 'NUMBER_NOT_VALID') {
			this.showNotification(
				`El nivel ${this.newType.level} ya está asignado a otro registro`,
				'error',
			);
		}
	}
}

function validations() {
	return {
		newType: {
			name: { required },
			level: { required },
		},
	};
}

function data() {
	return {
		newType: {
			name: '',
			level: '',
		},
	};
}

export default {
	name: 'new-type-form',
	components: {
		openModal,
	},
	data,
	methods: {
		closeModal,
		saveType,
	},
	validations,
};
</script>
<style lang="scss" scoped>
.type-form-container {
	height: 200px;

	h2 {
		border-bottom: 1px solid color(placeholder);
		padding-bottom: 10px;
	}

	form {
		align-items: center;
		display: flex;
		justify-content: flex-start;

		.name-input {
			flex-basis: 45%;
			margin-right: 20px;
			margin-top: 20px;
		}

		.level-input {
			flex-basis: 7%;
			margin-top: 20px;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/configuration/tools/new-type-form.vue